import { useRouter } from './use-router'
import { useService } from 'services'
import { GoToKey } from '@types'

export function useGoTo() {
  const { events } = useService()
  const router = useRouter()

  const persistState = (key: string, data: object) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(data))
    } catch (e) {
      events.error(e as Error)
    }
  }

  const clearState = (key: GoToKey) => {
    sessionStorage.removeItem(key)
  }

  const getCurrentState = (key: GoToKey, property?: string): unknown | null => {
    const item = sessionStorage.getItem(key)
    try {
      if (item === null) return null
      const parsedItem = JSON.parse(item)
      if (property) {
        return parsedItem ? parsedItem[property] : null
      }
      return parsedItem
    } catch (e) {
      events.error(e as Error)
    }
  }

  function pushPathname(pathname: string) {
    pathname.indexOf('http') > -1
      ? (window.location.href = pathname)
      : router.pushPreserveSearch(pathname)
  }

  function redirectByMatch(
    urlKey: GoToKey,
    destination: string,
    fallback?: string | (() => void)
  ) {
    const currentState = getCurrentState(urlKey)
    if (currentState) {
      pushPathname(destination)
      return
    }
    if (!fallback) return
    typeof fallback === 'string' ? pushPathname(fallback) : fallback()
  }

  return {
    persistState,
    clearState,
    getCurrentState,
    redirectByMatch,
  }
}
